module.exports = __webpack_public_path__ + "static/media/sat.d7eb383d.jpg";